import { formatJournalPath } from "../utils/formatJournalPath";

const JournalCard = ({ journal }) => {
  const slug = formatJournalPath(journal.jcr);
  const coverMap = {
    "current-pharmaceutical-analysis": "/images/journals/cpa.jpg",
    "current-molecular-pharmacology": "/images/journals/cmp.jpg",
    "current-genomics": "/images/journals/cg.jpg",
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "15px",
          marginBottom: "15px",
          backgroundColor: "#fff",
          transition: "box-shadow 0.3s ease",
          textAlign: "center",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)")
        }
        onMouseOut={(e) => (e.currentTarget.style.boxShadow = "none")}
      >
        <a
          href={`/issue/${formatJournalPath(journal.jcr)}/${journal.volume}/${journal.issued}`}
          style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
          <img
            // src={journal.cover_img} 对应某一期最新封面
            src={coverMap[slug]}
            alt={journal.jcr}
            style={{
              height: "auto",
              objectFit: "cover",
              borderRadius: "6px",
              border: "1px solid #e0e0e0",
              flexShrink: 0,
            }}
          />{" "}
          <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <h5
                style={{
                  margin: "0 ",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "1.3",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  color: "#003366"
                }}
              >
                {`Issue ${journal.issued} Volume ${journal.volume}`}
                {/* {journal.title} {journal.subtitle.match(/(Volume \d+)/i)[0]} */}
              </h5>
              <p
                style={{
                  color: "#888",
                  fontSize: "12px",
                  margin: "0",
                  fontWeight: "500",
                }}
              >
                {journal.jcr}
              </p>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};
export default JournalCard;